import { requireAuth } from 'routes'
import { injectReducer } from 'store/reducers'

export default (store) => ({
  childRoutes: [
    {
      path: '/content/site-audit',
      onEnter: requireAuth(store),
      getComponent (nextState, cb) {
        require.ensure([], (require) => {
        const SiteAudit = require('./containers/SiteAuditContainer').default
        const reducer = require('./modules/siteAudit').default
        injectReducer(store, { key: 'siteAudit', reducer })
          cb(null, SiteAudit)
        }, '')
      }
    },
    {
      path: 'content/site-audit/view/:id',
      getComponent (nextState, cb) {
        require.ensure([], (require) => {
        const ViewSiteAudit = require('./components/SiteAuditView').default
        cb(null, ViewSiteAudit)
      }, 'view-site-audit')
    }
  }]
})


